// extracted by extract-css-chunks-webpack-plugin
module.exports = {"preview":"preview-page__preview___3AKWT","delete-button":"preview-page__delete-button___2h3oF","deleteButton":"preview-page__delete-button___2h3oF"};
    if(module.hot) {
      // 1767926987088
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  